import React, { useState, useEffect } from 'react';
import ApiService from './services/apiservice';
import ima from './imasm.svg';
import { Link, useHistory, Redirect  } from 'react-router-dom';

const Registro = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('');
  const [error, setError] = useState(null);
  const history = useHistory();
  const apiService = new ApiService();

  const ubi = [
    { id: '1', title: 'Guatemala' },
    { id: '0', title: 'El Salvador' },
  ];

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      if (!name || !email || !country) {
        setError('Todos los campos son obligatorios');
        return;
      }

      const response = await apiService.register(name, email, country);

      if (response.status === true) {
        const userData = {
          email,
          idUsuario: response.data.id,
          country,
          expirationTime: new Date().setHours(23, 59, 59, 999),
        };

        localStorage.setItem('session', JSON.stringify(userData));

        if (country === '0') {
          history.push('/calendario-navideño-sv');
        } else if (country === '1') {
          history.push('/calendario-navideño-gt');
        }
      } else {
        setError('Error durante el registro');
        console.error('Registration failed:', response);
      }
    } catch (error) {
      setError('Error durante el registro');
      console.error('Error durante el registro:', error);
    }
  };

    useEffect(() => {
      const sessionData = JSON.parse(localStorage.getItem('session'));
      if (sessionData) {
        if (sessionData.country === '0') {
          history.push('/calendario-navideño-sv');
        } else if (sessionData.country === '1') {
          history.push('/calendario-navideño-gt');
        } else {
          history.push('/home')
        }
      }
    }, [history]);

  return (
    <div>
      <Redirect to="/home" />;
      <div data-aos="fade-down" className="space-y-10">
        <Link to="/home">
          <div className="flex flex-col justify-center items-center mt-4" data-aos="fade-right" data-aos-duration="1500">
            <img src={ima} alt="imasm" className="img" />
          </div>
        </Link>
  
        <div className="flex flex-col items-center">
          {error && <p style={{ color: 'white' }}>{error}</p>}
  
          <input
            type="text"
            name="name"
            id="name"
            className="custom-input"
            placeholder="Nombre"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
  
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            className="custom-input mt-4"
            placeholder="ejemplo-correo@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
  
          <div className="sel-ubi space-x-6">
            <label className="text-base font-semibold text-white">Seleccionar País:</label>
            {ubi.map((ubi) => (
              <div key={ubi.id}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input
                    name="country"
                    type="radio"
                    value={ubi.id.toString()}
                    checked={country === ubi.id.toString()}
                    onChange={() => {
                      setCountry(ubi.id.toString());
                    }}
                  />
                  <label htmlFor={ubi.id} className="text-white ml-4">
                    {ubi.title}
                  </label>
                </div>
              </div>
            ))}
          </div>
  
          <button className="buttonn" style={{ marginTop: '2rem' }} onClick={handleRegister}>
            Registrar
          </button>
        </div>
      </div>
    </div>
  );  
}

export default Registro;